import type { CoreData, CoreDataInner } from '@atlassian/forge-ui-types/public/effect';

import { parseExtensionId } from '../../../utils';
import type { Extension } from '../../../web-client';

/**
 * Extends the product-supplied `coreData` with the values derived from the extension and the
 * host page. Shared by every Forge runtime (iframe, worker) so the context object an app sees
 * is identical regardless of which runtime executes it.
 */
export const getCoreDataInner = (
	coreData: CoreData,
	extension: Pick<Extension, 'id' | 'environmentId' | 'environmentType'>,
): CoreDataInner => {
	const { moduleKey } = parseExtensionId(extension.id);
	return {
		...coreData,
		environmentId: extension.environmentId,
		environmentType: extension.environmentType,
		moduleKey,
		siteUrl: window.location.origin,
	};
};
